import { ReactComponent as ArrowRightFile } from 'assets/icons/arrow-right-icon.svg'

import { IconStyles } from '../types'
import { IconContainer } from './styles'
interface ArrowRightProps extends IconStyles {
  onClick?: any
}
const ArrowRigthIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}: ArrowRightProps) => {
  return (
    <IconContainer
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      colorIcon={colorIcon}
      onClick={onClick}
    >
      <ArrowRightFile />
    </IconContainer>
  )
}

export default ArrowRigthIcon
